export default "/_next/static/chunks/fonts/WhitneySSm-Light-Pro_Web-8c015177dd7588b08b4f53821f540823.woff";